import React from 'react';
import Button from '../../../../../../../../generic-components/Button';
import { ReactComponent as DeleteIcon } from '../../../../../../../../assets/icons/svg/shared/ic-shared-trash.svg';
import { ReactComponent as EditIcon } from '../../../../../../../../assets/svg/edit_pen_icon.svg';
import { IProduct } from '../../../../../types/types';
import Spinner, { SpinnerColor } from '../../../../../../../../generic-components/Spinner';

export const itemMenuTemplate = (
  item: IProduct,
  index: number,
  isLoading: boolean,
  onDeleteClick: (index: number) => void,
  onEditClick: (index: number) => void,
  enableDelete: boolean,
) => (
  <div className='flex items h-[64px] px-[12px] '>

    {isLoading ? <Spinner spinnerColor={SpinnerColor.Blue} height='2rem' width='2rem' />
      : (
        <div className=' flex transition flex-row z-10  justify-center  w-full gap-[4px]  rounded-md'>
          {enableDelete && (
          <Button
            className=''
            title=''
            id='delete_product_button'
            onClick={() => onDeleteClick(index)}
            childElement={(
              <div className='p-[4px] hover:bg-bw03 rounded-md '>
                <DeleteIcon className='w-[18px] h-[18px] text-bw07' />
              </div>
                  )}
          />
          ) }
          {item.serviceItemId && (
          <Button
            className=''
            title=''
            id='edit_product_button'
            onClick={() => onEditClick(index)}
            childElement={(
              <div className='p-[4px] hover:bg-bw03 rounded-md '>
                <EditIcon />
              </div>
                      )}
          />
          )}

        </div>
      )}

  </div>
);
